import React, { useEffect, useState } from "react";
import "./CollapsibleToggler.scss";
import {
  Text,
  IarrowUp,
  IarrowDown2
} from "agrofy-ui-components";
import { useStore } from "../../hooks/store";

const CollapsibleToggler = ({
  title,
  collapsed,
  lastItem,
  showCollapseBtn,
  children,
  titleColor,
  titleType,
  titleClass,
  image,
  subtitle
}) => {
  const [isCollapsed, setIsCollapsed] = useState(collapsed ? collapsed : false);

  const toggleCollapse = () => {
    setIsCollapsed(!isCollapsed);
  };
  const state = useStore()[0];
  useEffect(() => {
    if (!showCollapseBtn) {
      setIsCollapsed(false);
    }
  }, []);

  return (
    <>
      <span
        className={[
          "Title",
          !isCollapsed && children
            ? "expandedTitle noBorder"
            : lastItem
              ? "noBorder"
              : null,
        ].join(" ")}
      >
        {image ? <img className="logo" src={image + "?usewebp=true"} /> : null}
        <div className="TitleContent">
          <span>
            <Text className={titleClass} type={titleType} color={titleColor} tag="h3" ma="0">
              {title}
            </Text>
            {subtitle ? (<Text>{subtitle}</Text>) : null}
          </span>
        </div>
        <span className="iconContainer">
          {showCollapseBtn ? (
            isCollapsed ? (
              <div className="iconTop">
                <IarrowDown2
                  onClick={() => toggleCollapse()}
                  width="24px"
                  height="24px"
                  fill="green5"
                />
              </div>
            ) : (
              <div className="iconTop">
                <IarrowUp
                  onClick={() => toggleCollapse()}
                  width="24px"
                  height="24px"
                  fill="green5"
                />
              </div>
            )
          ) : null}
        </span>
      </span>
      <div
        className={[
          isCollapsed || !children
            ? "d-mobile isCollapsed"
            : "d-mobile isExpanded childrenContainer",
        ].join(" ")}
      >
        {children}
      </div>
      <div
        className={[
          isCollapsed || !children
            ? "d-desktop isCollapsed"
            : "d-desktop isExpanded",
        ].join(" ")}
      >
        {children}
      </div>
    </>
  );
};

export default CollapsibleToggler;
